import { Icon } from './Icon'
import './FreemiumMessage.css'

/**
 * FreemiumMessage Component
 * 
 * Displays freemium tier messaging for empty states and onboarding.
 * Appears when user has no projects or in onboarding flows.
 * 
 * Copy from Master Plan Section 7.3 (Freemium + Credits)
 */
export function FreemiumMessage({ 
  variant = 'default', // 'default' | 'compact' | 'inline'
  showCreditsInfo = true,
  className = '' 
}) {
  if (variant === 'inline') {
    return (
      <div className={`freemium-message freemium-message--inline ${className}`}>
        <Icon name="star" size={14} />
        <span>No subscription required to start</span>
      </div>
    )
  }

  if (variant === 'compact') {
    return (
      <div className={`freemium-message freemium-message--compact ${className}`}>
        <div className="freemium-message__icon">
          <Icon name="star" size={20} />
        </div>
        <div className="freemium-message__content">
          <p className="freemium-message__headline">Start building for free</p>
          <p className="freemium-message__subhead">Try the core tools. Upgrade only when you need more.</p>
        </div>
      </div>
    )
  }

  // Default variant - full message
  return (
    <div className={`freemium-message ${className}`}>
      <div className="freemium-message__header">
        <div className="freemium-message__icon">
          <Icon name="star" size={24} />
        </div>
        <h3 className="freemium-message__headline">Start building for free</h3>
      </div>
      
      <p className="freemium-message__subhead">
        Try the core tools. Upgrade only when you need more.
      </p>
      
      <p className="freemium-message__core-copy">
        Build a small project, experiment with ideas, and get a feel for the workflow.
      </p>
      
      {showCreditsInfo && (
        <div className="freemium-message__credits-info">
          <Icon name="credits" size={16} />
          <p>
            Credits unlock advanced actions like AI generation, imports, or large expansions—only when you need them.
          </p>
        </div>
      )}
      
      <p className="freemium-message__trust-line">
        <Icon name="check" size={14} />
        No subscription required to start
      </p>
    </div>
  )
}
